<div class="admin-app-layout">
  <!-- ════ TOPBAR ════ -->
  <header class="topbar">
    <button type="button" class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Abrir menu">
      <i class="fas fa-bars"></i>
    </button>
    <a [routerLink]="['/admin']" class="topbar-logo" aria-label="FundCube Admin">
      <img src="images/fundCubeLogo.png" alt="FundCube" class="topbar-logo-img" />
    </a>
    <div class="topbar-divider"></div>
    <span class="topbar-title">Painel Administrativo</span>

    <div class="topbar-right">
      <a [routerLink]="['/']" class="btn btn-outline btn-sm hide-mobile" title="Ir para o Portal">
        <i class="fas fa-globe"></i> Portal
      </a>
      <div class="topbar-user">
        <div class="topbar-avatar">{{ initials || 'AD' }}</div>
        <div class="topbar-user-info hide-mobile">
          <div class="topbar-user-name">{{ utilizador?.userName || 'Administrador' }}</div>
          <div class="topbar-user-role">Gestão FundCube</div>
        </div>
      </div>
    </div>
  </header>

  <!-- ════ SIDEBAR OVERLAY FOR MOBILE ════ -->
  <div class="sidebar-overlay" [class.show]="sidebarOpen" (click)="closeSidebar()"></div>

  <!-- ════ SIDEBAR ════ -->
  <aside class="sidebar" [class.open]="sidebarOpen">
    <div class="sidebar-profile">
      <div class="sp-avatar-wrap">
        <div class="sp-avatar">{{ initials || 'AD' }}</div>
        <span class="sp-status"></span>
      </div>
      <div class="sp-name">{{ utilizador?.userName || 'Administrador' }}</div>
      <div class="sp-email">{{ utilizador?.email || 'admin@fundcube.ao' }}</div>
      <span class="sp-badge"><i class="fas fa-shield-alt"></i> Administrador</span>
    </div>

    <nav class="sidebar-nav">
      <div class="sidebar-nav-label">Menu Principal</div>

      <a [routerLink]="['/admin/estatisticas']" routerLinkActive="active" class="sidebar-link" (click)="closeSidebar()">
        <i class="fas fa-chart-line"></i>
        <span>Estatísticas</span>
      </a>

      <a [routerLink]="['/admin/campanhas']" routerLinkActive="active" class="sidebar-link" (click)="closeSidebar()">
        <i class="fas fa-bullhorn"></i>
        <span>Campanhas</span>
        <span class="sl-badge" *ngIf="totalCampanhas">{{ totalCampanhas }}</span>
      </a>

      <a [routerLink]="['/admin/utilizadores']" routerLinkActive="active" class="sidebar-link" (click)="closeSidebar()">
        <i class="fas fa-users"></i>
        <span>Utilizadores</span>
        <span class="sl-badge" *ngIf="totalUtilizadores">{{ totalUtilizadores }}</span>
      </a>

      <a [routerLink]="['/admin/pagamentos']" routerLinkActive="active" class="sidebar-link" (click)="closeSidebar()">
        <i class="fas fa-hand-holding-usd"></i>
        <span>Pagamentos</span>
        <span class="sl-badge" *ngIf="totalPagamentos">{{ totalPagamentos }}</span>
      </a>

      <div class="sidebar-sep"></div>
      <div class="sidebar-nav-label">Sistema</div>

      <a [routerLink]="['/admin/registos']" routerLinkActive="active" class="sidebar-link" (click)="closeSidebar()">
        <i class="fas fa-list-check"></i>
        <span>Registos</span>
        <span class="sl-badge amber" *ngIf="totalRegistos">{{ totalRegistos }}</span>
      </a>

      <a [routerLink]="['/admin/configuracoes']" routerLinkActive="active" class="sidebar-link"
        (click)="closeSidebar()">
        <i class="fas fa-cog"></i>
        <span>Configurações</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <a [routerLink]="['/']" class="sidebar-footer-link" (click)="closeSidebar()">
        <i class="fas fa-home"></i> Ir para Portal
      </a>
      <a href="javascript:void(0)" class="sidebar-footer-link danger" (click)="logout()">
        <i class="fas fa-sign-out-alt"></i> Terminar Sessão
      </a>
    </div>
  </aside>

  <!-- ════ MAIN CONTENT AREA ════ -->
  <main class="dash-main">
    <div class="dash-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>